const initialState = {
  placeholderPermissions: {},
  placeholderLists: [],
  placeholderAll: null,
  placeholderGroups: [],
  placeholderCompanies: [],
  placeholderMappings: [],
  placeholderMappingsForEdit: [],
  placeholderMappingsForScan: [],
  placeholderById: null,
  placeholderActivityLogs: [],
  placeholderCount: 0,
  changedPlaceholderStatus: [],
  loadingPlaceholder: false,
  loadingPlaceholderLogs: false,
  errorsPlaceholder: {},
};

const placeholderReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_PLACEHOLDERLIST_PENDING":
    case "GET_PLACEHOLDERLIST_ALL_PENDING":
    case "GET_PLACEHOLDER_GROUPS_PENDING":
    case "GET_PLACEHOLDER_COMPANIES_PENDING":
    case "GET_PLACEHOLDER_MAPPINGS_PENDING":
    case "GET_PLACEHOLDER_FOR_EDIT_PENDING":
    case "GET_PLACEHOLDER_FOR_SCAN_PENDING":
    case "GET_PLACEHOLDERLISTBYID_PENDING":
    case "ADD_PLACEHOLDER_GROUP_PENDING":
    case "ADD_PLACEHOLDER_PENDING":
    case "ADD_PLACEHOLDER_LABEL_PENDING":
    case "BULK_ADD_PLACEHOLDER_PENDING":
    case "UPDATE_PLACEHOLDER_PENDING":
    case "DELETE_PLACEHOLDER_PENDING":
    case "DELETE_PLACEHOLDER_LABEL_PENDING":
      return { ...state, loadingPlaceholder: true };

    case "GET_PLACEHOLDER_ACTIVITY_LOGS_PENDING":
      return { ...state, loadingPlaceholderLogs: true };

    case "GET_PLACEHOLDERLIST_FULFILLED":
      return {
        ...state,
        loadingPlaceholder: false,
        placeholderLists: action.payload,
        placeholderCount: action.placeholderCount,
        placeholderPermissions: action.permissions,
        errorsPlaceholder: {},
      };

    case "GET_PLACEHOLDERLIST_ALL_FULFILLED":
      return {
        ...state,
        loadingPlaceholder: false,
        placeholderAll: action.payload,
        errorsPlaceholder: {},
      };

    case "GET_PLACEHOLDER_GROUPS_FULFILLED":
      return {
        ...state,
        loadingPlaceholder: false,
        placeholderGroups: action.payload,
        errorsPlaceholder: {},
      };

    case "GET_PLACEHOLDER_COMPANIES_FULFILLED":
      return {
        ...state,
        loadingPlaceholder: false,
        placeholderCompanies: action.payload,
        errorsPlaceholder: {},
      };

    case "GET_PLACEHOLDER_MAPPINGS_FULFILLED":
      return {
        ...state,
        loadingPlaceholder: false,
        placeholderMappings: action.payload,
        errorsPlaceholder: {},
      };

    case "GET_PLACEHOLDER_FOR_EDIT_FULFILLED":
      return {
        ...state,
        loadingPlaceholder: false,
        placeholderMappingsForEdit: action.payload,
        errorsPlaceholder: {},
      };

    case "GET_PLACEHOLDER_FOR_SCAN_FULFILLED":
      return {
        ...state,
        loadingPlaceholder: false,
        placeholderMappingsForScan: action.payload,
        errorsPlaceholder: {},
      };

    case "GET_PLACEHOLDERLISTBYID_FULFILLED":
      return {
        ...state,
        loadingPlaceholder: false,
        placeholderById: action.payload,
        errorsPlaceholder: {},
      };

    case "GET_PLACEHOLDER_ACTIVITY_LOGS_FULFILLED":
      return {
        ...state,
        loadingPlaceholderLogs: false,
        placeholderActivityLogs: action.payload,
        errorsPlaceholder: {},
      };

    case "ADD_PLACEHOLDER_GROUP_FULFILLED":
    case "ADD_PLACEHOLDER_FULFILLED":
    case "ADD_PLACEHOLDER_LABEL_FULFILLED":
    case "BULK_ADD_PLACEHOLDER_FULFILLED":
    case "UPDATE_PLACEHOLDER_FULFILLED":
    case "DELETE_PLACEHOLDER_FULFILLED":
    case "DELETE_PLACEHOLDER_LABEL_FULFILLED":
      return {
        ...state,
        loadingPlaceholder: false,
        changedPlaceholderStatus: action.payload,
        errorsPlaceholder: {},
      };

    case "RESET_PLACEHOLDER_STATUS":
      return {
        ...state,
        loadingPlaceholder: false,
        loadingPlaceholderLogs: false,
        changedPlaceholderStatus: [],
        placeholderActivityLogs: [],
        errorsPlaceholder: {},
      };

    case "GET_PLACEHOLDERLIST_REJECTED":
    case "GET_PLACEHOLDERLIST_ALL_REJECTED":
    case "GET_PLACEHOLDER_GROUPS_REJECTED":
    case "GET_PLACEHOLDER_COMPANIES_REJECTED":
    case "GET_PLACEHOLDER_MAPPINGS_REJECTED":
    case "GET_PLACEHOLDER_FOR_EDIT_REJECTED":
    case "GET_PLACEHOLDER_FOR_SCAN_REJECTED":
    case "GET_PLACEHOLDERLISTBYID_REJECTED":
    case "ADD_PLACEHOLDER_GROUP_REJECTED":
    case "ADD_PLACEHOLDER_REJECTED":
    case "ADD_PLACEHOLDER_LABEL_REJECTED":
    case "BULK_ADD_PLACEHOLDER_REJECTED":
    case "UPDATE_PLACEHOLDER_REJECTED":
    case "DELETE_PLACEHOLDER_REJECTED":
    case "DELETE_PLACEHOLDER_LABEL_REJECTED":
      return {
        ...state,
        loadingPlaceholder: false,
        errorsPlaceholder: action.payload,
      };

    case "GET_PLACEHOLDER_ACTIVITY_LOGS_REJECTED":
      return {
        ...state,
        loadingPlaceholderLogs: false,
        placeholderActivityLogs: [],
        errorsPlaceholder: action.payload,
      };

    default:
      return state;
  }
};

export default placeholderReducer;
